<template>
  <el-dialog
    width="1080px"
    custom-class="custom_license_dialog"
    append-to-body
    :fullscreen="isFullscreen"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <div slot="title" class="dialog_title">
      <span>单独配置授权</span>
      <el-tooltip :content="isFullscreen ? '还原窗口' : '放大窗口'" placement="bottom">
        <el-button type="text" class="fullscreen_button" @click="toggleFullscreen">
          <i :class="isFullscreen ? 'el-icon-copy-document' : 'el-icon-full-screen'"></i>
        </el-button>
      </el-tooltip>
    </div>
    <div v-loading="loading">
      <div class="list_summary">
        <span>订单号：{{ orderNum }}</span>
        <span>共 {{ tableData.length }} 个授权</span>
      </div>
      <el-table :data="tableData" :max-height="tableMaxHeight" border>
        <el-table-column prop="id" label="授权编号" width="90" align="center" />
        <el-table-column prop="license_code" label="激活码" width="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.license_code || '未生成' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.is_activate ? '已激活' : '未激活' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="配置差异" min-width="310">
          <template slot-scope="{ row }">
            <div v-for="item in row.differences" :key="item.module_code" class="difference_item">
              <span>{{ item.module_name }}</span>
              <span class="difference_value">{{ item.order_value }} -> {{ item.license_value }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleView(row)">查看详情</el-button>
            <el-button type="text" @click="handleEdit(row)">编辑配置</el-button>
            <el-button type="text" @click="handleRestore(row)">恢复订单配置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <span slot="footer">
      <el-button size="small" @click="handleClose">关闭</el-button>
    </span>

    <productDetail
      v-if="productDetailVisible"
      :productDetailVisible.sync="productDetailVisible"
      :productId="productId"
      @success="handleProductSuccess" />
    <modulesChange
      v-if="modulesVisible"
      :modulesVisible.sync="modulesVisible"
      :modulesInfo="modulesInfo"
      :dialogTitle="editDialogTitle"
      :contextText="editingProductName"
      @success="handleModulesSuccess" />
  </el-dialog>
</template>

<script>
import {
  adminLicenseConfigEdit,
  adminLicenseConfigRestore,
  adminOrderCustomLicenses,
  adminUserProductDetail
} from '@/api/api'
import productDetail from '../individual_users/product_detail.vue'
import modulesChange from '../individual_users/modules_change.vue'

export default {
  name: 'custom_license_list',
  components: {
    productDetail,
    modulesChange
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      orderNum: '',
      tableData: [],
      isFullscreen: false,
      productDetailVisible: false,
      productId: 0,
      modulesVisible: false,
      modulesInfo: [],
      editingLicenseId: 0,
      editingLicenseCode: '',
      editingProductName: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      adminOrderCustomLicenses({ id: this.orderId }).then(res => {
        if (res.code === 200) {
          this.orderNum = res.data.order_num
          this.tableData = res.data.data
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleView(row) {
      this.productId = row.id
      this.productDetailVisible = true
    },
    handleEdit(row) {
      this.loading = true
      adminUserProductDetail({ id: row.id }).then(res => {
        if (res.code === 200) {
          this.editingLicenseId = row.id
          this.editingLicenseCode = row.license_code || `授权 #${row.id}`
          this.editingProductName = res.data.product ? res.data.product.product_name : ''
          this.modulesInfo = res.data.license_modules || []
          this.modulesVisible = true
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleModulesSuccess(data) {
      const moduleRequire = data.map(item => {
        return {
          module_id: item.module_id,
          module_code: item.module_code,
          module_value_id: item.module_value_id,
          module_value: item.module_value,
          value_code: item.value_code
        }
      })
      this.loading = true
      adminLicenseConfigEdit({
        id: this.editingLicenseId,
        module_require: moduleRequire
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.getData()
          this.$emit('success')
        } else {
          this.loading = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleRestore(row) {
      this.$confirm('恢复后，该授权将重新使用订单配置。', '恢复订单配置', {
        confirmButtonText: '确认恢复',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return adminLicenseConfigRestore({ id: row.id })
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.getData()
          this.$emit('success')
        }
      }).catch(() => {})
    },
    handleProductSuccess() {
      this.getData()
      this.$emit('success')
    },
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen
    },
    handleClose() {
      this.$emit('update:visible', false)
    }
  },
  computed: {
    editDialogTitle() {
      return `编辑配置 - ${this.editingLicenseCode}`
    },
    tableMaxHeight() {
      return this.isFullscreen ? 'calc(100vh - 190px)' : 560
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .custom_license_dialog:not(.is-fullscreen) {
  max-width: calc(100% - 48px);
}
.dialog_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 34px;
}
.fullscreen_button {
  padding: 0;
  color: #909399;
  font-size: 18px;
}
.fullscreen_button:hover {
  color: #409eff;
}
.list_summary {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  color: #606266;
}
.difference_item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  line-height: 24px;
}
.difference_value {
  color: #606266;
  white-space: nowrap;
}
</style>
